import { GridColDef } from '@mui/x-data-grid-pro';

export const classroomColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Navn',
    flex: 1,
  },
  {
    field: 'companyName',
    headerName: 'Virksomhed',
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: 'Aktiv',
    flex: 1,
    valueGetter: ({ value }) => (value ? 'Ja' : 'Nej'),
  },
];
